// extracted by css-extract-rspack-plugin
export default {"cls1":"ButtonsPage-cls1_hW0","cls2":"ButtonsPage-cls2_14l ButtonsPage-cls1_hW0","show":"ButtonsPage-show_tN_"};